import React from "react";
import {Spinner} from "reactstrap";

export default function Preloader({children = "טוען, אנא המתינו"}) {
    return <div className="w-100 h-100 d-flex justify-content-center flex-column align-items-center">
        <h3>{children}</h3>
        <Spinner size={"lg"} />
    </div>
}
